import type { TransactionFilters } from '@carboncopyco/editor-utils';
import {
  contentTypeCategoryToLabel,
  supportedContentTypeCategories,
} from '@carboncopyco/editor-utils';
import { DropdownFilter } from '@carboncopyco/ui';
import { useState } from 'react';

export interface TransactionSearchFiltersProps {
  onChange?: (filters: TransactionFilters) => void;
}

export const TransactionSearchFilters = ({
  onChange,
}: TransactionSearchFiltersProps) => {
  const [filters, setFilters] = useState<TransactionFilters>({});

  const changeFilter = (filter: Partial<TransactionFilters>) => {
    const updatedFilters = { ...filters, ...filter };
    setFilters(updatedFilters);
    onChange?.(updatedFilters);
  };

  const getFilterProps = <T extends keyof TransactionFilters>(
    filterName: T
  ) => {
    return {
      onSelect: (filter) => changeFilter({ [filterName]: filter }),
      selected: filters[filterName],
      contentWidth: 200,
      onClear: () => changeFilter({ [filterName]: undefined }),
    };
  };

  return (
    <div className="flex gap-2.5">
      <DropdownFilter<TransactionFilters['method']>
        placeholder="Method"
        items={[
          { id: 'GET', label: 'GET' },
          { id: 'POST', label: 'POST' },
          { id: 'PUT', label: 'PUT' },
          { id: 'PATCH', label: 'PATCH' },
          { id: 'DELETE', label: 'DELETE' },
        ]}
        {...getFilterProps('method')}
      />
      <DropdownFilter<TransactionFilters['statusCategory']>
        placeholder="Response Code"
        items={[
          { id: 'successful', label: '2XX' },
          { id: 'redirection', label: '3XX' },
          { id: 'clientError', label: '4XX' },
          { id: 'serverError', label: '5XX' },
        ]}
        {...getFilterProps('statusCategory')}
      />
      <DropdownFilter<TransactionFilters['responseContentType']>
        placeholder="Content Type"
        items={supportedContentTypeCategories.map((category) => ({
          id: category,
          label: contentTypeCategoryToLabel[category],
        }))}
        {...getFilterProps('responseContentType')}
      />
    </div>
  );
};
